import React from "react";
import { Text, Card } from "@jsq/ds/core";
import * as loginCardStyles from "./styles_vanilla.css";

export type LoginCardProps = {
  cardTitle: string;
  children: React.ReactNode;
};

export const LoginCard: React.FC<LoginCardProps> = ({ cardTitle, children }) => (
  <Card className={loginCardStyles.loginCardMain}>
    <Text align="center" variant="h2" marginBottom="xl">
      {cardTitle}
    </Text>
    {children}
  </Card>
);
